/* eslint-disable prefer-destructuring,no-control-regex */
/* eslint-disable no-dupe-else-if */
/* eslint-disable no-use-before-define,id-length,no-param-reassign,max-len, no-shadow, no-restricted-properties */

/**
 * 转换边框线段值,比如"6 4 0 4 0 4"转为"40 26.66667 0 26.66667 0 26.66667"
 * @param borderWidth
 */
export function transBorderDashArray(dashStr: string, borderWidth: number): string {
    const dashArray: string[] = dashStr.split(' ');
    if (dashArray instanceof Array) {
        return dashArray.map(item => Number(item) * borderWidth).join(' ');
    }
    return dashStr;
}

/** *------------------------rotate/resize/flip/drag begin--------------------------------** */

export function getFlipCursor(c: string, flipH: number, flipV: number): string {
    let cursor: string = c;
    if ((flipH === 1 && flipV !== 1) || (flipH !== 1 && flipV === 1)) {
        if (cursor === 'nwse-resize') {
            cursor = 'nesw-resize';
        } else if (cursor === 'nesw-resize') {
            cursor = 'nwse-resize';
        }
    }
    return cursor;
}

export function getCursorWithRotate(rotate: number, props: any, flipH: number, flipV: number): string {
    let cursor = 'auto';
    if (isCursorAlgin1WithRotate(rotate))  {
        // 旋转角度在以竖向中轴线为基础的左右22.5度范围内
        cursor = getCursorAlgin1(props);
    } else if (isCursorAlgin2WithRotate(rotate)) {
        // 旋转角度在以东北对角线为基础的左右22.5度范围
        cursor = getCursorAlgin2(props);
    } else if (isCursorAlgin3WithRotate(rotate)) {
        // 旋转角度在以横向中轴线为基础的左右22.5度范围
        cursor = getCursorAlgin3(props);
    } else if (isCursorAlgin4WithRotate(rotate)) {
        // 旋转角度在以西北对角线为基础的左右22.5度范围
        cursor = getCursorAlgin4(props);
    }

    return getFlipCursor(cursor, flipH, flipV);
}

function isCursorAlgin1WithRotate(rotate: number): boolean {
    return rotate >= 337 || rotate < 22.5 || (rotate >= 157 && rotate < 157 + 45);
}
function isCursorAlgin2WithRotate(rotate: number): boolean {
    return rotate < 22.5 + 45 || (rotate >= 157 + 45 && rotate < 157 + 45 + 45);
}
function isCursorAlgin3WithRotate(rotate: number): boolean {
    return rotate < 22.5 + 45 + 45 || (rotate >= 157 + 45 + 45 && rotate < 157 + 45 + 45 + 45);
}
function isCursorAlgin4WithRotate(rotate: number): boolean {
    return rotate < 22.5 + 45 + 45 + 45 || (rotate >= 157 + 45 + 45 + 45 && rotate < 157 + 45 + 45 + 45 + 45);
}
export function getCursorAlgin1(props: any): string {
    let cursor = 'auto';
    if (props.alignTop) {
        cursor = 'ns-resize';
    } else if (props.cornerTopRight) {
        cursor = 'nesw-resize';
    } else if (props.alignRight) {
        cursor = 'ew-resize';
    } else if (props.cornerBottomRight) {
        cursor = 'nwse-resize';
    } else if (props.alignBottom) {
        cursor = 'ns-resize';
    } else if (props.cornerBottomLeft) {
        cursor = 'nesw-resize';
    } else if (props.alignLeft) {
        cursor = 'ew-resize';
    } else if (props.cornerTopLeft) {
        cursor = 'nwse-resize';
    }
    return cursor;
}

export function getCursorAlgin2(props: any): string {
    let cursor = 'auto';
    if (props.alignTop) {
        cursor = 'nesw-resize';
    } else if (props.cornerTopRight) {
        cursor = 'ew-resize';
    } else if (props.alignRight) {
        cursor = 'nwse-resize';
    } else if (props.cornerBottomRight) {
        cursor = 'ns-resize';
    } else if (props.alignBottom) {
        cursor = 'nesw-resize';
    } else if (props.cornerBottomLeft) {
        cursor = 'ew-resize';
    } else if (props.alignLeft) {
        cursor = 'nwse-resize';
    } else if (props.cornerTopLeft) {
        cursor = 'ns-resize';
    }
    return cursor;
}

export function getCursorAlgin3(props: any): string {
    let cursor = 'auto';
    if (props.alignTop) {
        cursor = 'ew-resize';
    } else if (props.cornerTopRight) {
        cursor = 'nwse-resize';
    } else if (props.alignRight) {
        cursor = 'ns-resize';
    } else if (props.cornerBottomRight) {
        cursor = 'nesw-resize';
    } else if (props.alignBottom) {
        cursor = 'ew-resize';
    } else if (props.cornerBottomLeft) {
        cursor = 'nwse-resize';
    } else if (props.alignLeft) {
        cursor = 'ns-resize';
    } else if (props.cornerTopLeft) {
        cursor = 'nesw-resize';
    }
    return cursor;
}

export function getCursorAlgin4(props: any): string {
    let cursor = 'auto';
    if (props.alignTop) {
        cursor = 'nwse-resize';
    } else if (props.cornerTopRight) {
        cursor = 'ns-resize';
    } else if (props.alignRight) {
        cursor = 'nesw-resize';
    } else if (props.cornerBottomRight) {
        cursor = 'ew-resize';
    } else if (props.alignBottom) {
        cursor = 'nwse-resize';
    } else if (props.cornerBottomLeft) {
        cursor = 'ns-resize';
    } else if (props.alignLeft) {
        cursor = 'nesw-resize';
    } else if (props.cornerTopLeft) {
        cursor = 'ew-resize';
    }
    return cursor;
}
